import type { ReactNode } from 'react'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import './SuccessBlock.css'

export interface SuccessBlockProps {
  /** h3, p. ej. "Fianza reservada" */
  title: ReactNode
  /** Importe ya formateado, en display */
  amount?: ReactNode
  children?: ReactNode
  /** Botón o enlace de continuación */
  action?: ReactNode
  headingLevel?: 2 | 3
  className?: string
}

/** Bloque de confirmación (bundle §Kg "Fianza reservada"): fondo success-soft, icono, h3, importe y texto. */
export function SuccessBlock({ title, amount, children, action, headingLevel = 3, className }: SuccessBlockProps) {
  const Heading = headingLevel === 2 ? 'h2' : 'h3'
  return (
    <div className={cx('hp-success', className)} role="status">
      <div className="hp-success__head">
        <Icon name="check-circle" size={24} className="hp-success__icon" />
        <Heading className="hp-success__title">{title}</Heading>
      </div>
      {amount && <div className="hp-success__amount tnum">{amount}</div>}
      {children && <p className="hp-success__text">{children}</p>}
      {action}
    </div>
  )
}
